import angular from 'angular';

import GamesEndingCardComponent from './components/games-ending-card-component';
import GamesEndingWidgetComponent from './games-ending-component';

export default angular
  .module('games-ending', [])
  .component('gamesEndingCard', new GamesEndingCardComponent())
  .component('gamesEnding', new GamesEndingWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/games-ending/games-ending-widget-module.js